import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function resendInvitationAPI(email) {
  const url = `${AWS_API_URL}/admin/users/resend-invite`;

  const body = {
    data: {
      email,
    },
  };

  return postRequest(url, body, await authorize());
}
